import React from 'react';
import HelpIcon from './HelpIcon';

const YesNoInput = ({
  label,
  name,
  options,
  register,
  errors,
  validation,
  align = 'left',
  sx = {},
  showRequiredIndicator = false,
  helptext
}) => (
  <div className="form-group radio-group" style={{ textAlign: align }}>
    <div style={{display: 'inline'}}>
      {label}
      {showRequiredIndicator && <span className="required-indicator">*</span>}
      <HelpIcon helptext={helptext} />
    <div style={{display: 'inline', float:'right' }} >
    {[{label: 'Yes', value:'Yes'},{label: 'No', value: 'No'}].map((opt, idx) => (
      <label key={idx} style={{display: 'inline', marginRight: '15px'}}>
        <input
          key={`yesno_rad_${idx}`} 
          type="radio"
          value={opt.value}
          style={{...(opt.sx || sx), ...{display: 'inline'} } }
          {...register(name, validation)}
        />
        {opt.label}
      </label>
    ))}
    </div>
    </div>
    {errors[name] && <p style={{ color: 'red' }}>{errors[name].message}</p>}
  </div>
);

export default YesNoInput;
